import React, { memo } from 'react';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import Button from 'components/CustomButtons/Button';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/FixedBusinessBroadband/oneLineStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import { MIN_LINE_NAME_LENGTH } from 'views/AddNewServices/AddSingleService/constants';
import LineFbb from './LineFbb';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ILinesOneLineProps {
	ind: number;
	showNumber?: boolean;
	lines: types.services.fixed.fixedBusinessBroadband.ILine[];
	line: types.services.fixed.fixedBusinessBroadband.ILine;
	handleEditName: (name: string, ind: number) => void;
	error?: string;
	handleRemoveItem: (ind: number) => void;
}

const LinesOneLine = memo((props: ILinesOneLineProps) => {
	const { ind, lines, showNumber = false, line, handleEditName, handleRemoveItem, error } = props;

	const classes = useStyles();
	return (
		<div key={line.id} className={classes.lineContainer}>
			<div className={classes.lineInputContainer}>
				<LineFbb
					{...line}
					ind={lines.length - ind}
					showIcon={false}
					error={error}
					handleEditName={(name: string) => handleEditName(name, ind)}
					showNumber={showNumber && lines.length > 1}
					minLineNameLength={MIN_LINE_NAME_LENGTH}
				/>
			</div>
			<ConditionalRender
				show={lines.length > 1}
				onTrue={() => (
					<Button
						color="tertiary-danger"
						className={classes.deleteButton}
						size="sm"
						onClick={() => handleRemoveItem(ind)}
					>
						{translate('add.new.line.fixed.deleteLine')}
					</Button>
				)}
			/>
		</div>
	);
});

export default LinesOneLine;
